import React, { useState, useEffect, useRef } from 'react';
import { Input } from 'reactstrap';

function AmountInputProps({ value, onChange, disabled, error }) {
  const [displayValue, setDisplayValue] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (
      inputRef.current &&
      value !== undefined &&
      value !== null &&
      document.activeElement !== inputRef.current
    ) {
      setDisplayValue(
        Number(value).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      );
    }
  }, [value]);

  const handleChange = e => {
    const { selectionStart } = e.target;
    const raw = e.target.value.replace(/,/g, '');

    if (/^\d*\.?\d*$/.test(raw)) {
      setDisplayValue(raw);
      onChange(raw === '' ? null : parseFloat(raw));

      // restore cursor safely
      setTimeout(() => {
        if (inputRef.current && inputRef.current.setSelectionRange) {
          inputRef.current.setSelectionRange(selectionStart, selectionStart);
        }
      }, 0);
    }
  };

  const handleBlur = () => {
    if (displayValue === '') return;
    const num = parseFloat(displayValue.replace(/,/g, ''));
    if (!Number.isNaN(num)) {
      const formatted = num.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      setDisplayValue(formatted);
      onChange(num);
    }
  };

  const handleFocus = () => {
    if (displayValue === '0.00') {
      setDisplayValue('');
    }
  };

  return (
    <Input
      innerRef={inputRef}
      type="text"
      value={displayValue}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      disabled={disabled}
      className={`eec-input claim-row-input ${error ? 'is-invalid' : ''}`}
      placeholder="0.00"
      title={error ? 'Amount should be greater than 0' : ''}
    />
  );
}

export default AmountInputProps;
